import React, { useState } from 'react';
import { FaRegStar, FaStar, FaStarHalfAlt } from 'react-icons/fa';

const ReviewCard = ({ review, renderStars }) => {
    const [isExpanded, setIsExpanded] = useState(false);

    const toggleReadMore = () => {
        setIsExpanded(!isExpanded);
    };

    return (
        <div className="bg-slate-100 p-2 rounded-lg my-2">
            <h2 className="font-semibold">
                {review.username || "Anonymous"}
            </h2>
            <div className="flex items-center mt-1 sm:mt-2 space-x-1">
                {renderStars(review.rating)}
                <p className="text-gray-500 text-sm ml-2">
                    {review.rating.toFixed(1)}
                </p>
            </div>
            <p className={`text-black mt-1 ${!isExpanded ? "line-clamp-4" : ""}`}>
                {review.comments}
            </p>
            {review.comments.length > 200 && ( // Display "Read More" if the text is lengthy
                <button
                    onClick={toggleReadMore}
                    className="text-brand-primary  text-sm mt-2 focus:outline-none hover:underline"
                >
                    {isExpanded ? "Read Less" : "Read More"}
                </button>
            )}
        </div>
    );
};

export default ReviewCard;
